import{b as C}from"./utils-Ids_YAaU.js";const P=(a,{isSlide:e=!1}={})=>{var $,b,u,h,f,g,B,y;const{key:l,title:c,link:w,imageInfo:d,sellingPrice:i,listPrice:n,custom:t,ticket:r}=a,k=window.themeVars.localization.market!=="en-GB"?`/${window.themeVars.localization.market.toLowerCase()}`:"",v=(d==null?void 0:d.thumbnail)||((h=(u=(b=($=d==null?void 0:d.images)==null?void 0:$[0])==null?void 0:b.sources)==null?void 0:u[0])==null?void 0:h.url)||"",p=(i==null?void 0:i.min)||0,_=(n==null?void 0:n.min)>(i==null?void 0:i.min)?n.min:0,o=(g=(f=t==null?void 0:t.product_hover_image)==null?void 0:f[0])==null?void 0:g.label,s=(y=(B=t==null?void 0:t.colour_count)==null?void 0:B[0])==null?void 0:y.label;return`
    <${e?"li":"div"}
      class="product-card ${e?"splide__slide":""}"
      data-voyado-product
      data-product-key="${l}"
      data-product-ticket="${r}"
    >
      ${N(t,p,_)}
      ${S(a)}
      <a 
        href="${k}${w}"
        class="product-card__image-container ${o?"has-hover":""}"
      >
        <img 
          src="${v}" 
          alt="Image of ${c}"
          class="product-card__image-container--primary" 
        />
        ${o?`
          <img 
            src="${o}" 
            alt="Secondary image of ${c}" 
            class="product-card__image-container--secondary" 
          />
        `:""}
      </a>
      <div class="product-card__content">
        <p class="product-card__title f1-lc">${c}</p>
        ${x(p,_)}
      </div>
       <p
        data-product-id="${l}" 
        class="product-card__taggstar f2-lc"
      >
      </p>
      ${s&&s>1?`
        <p class="product-card__colour-count f2-lc">
          ${s} Colours
        </p>
      `:""}
    </${e?"li":"div"}>
  `},x=(a,e)=>{let l="",c="product-card__price--current";return e&&(l=`
      <span class="product-card__price--original f1-lc">
        ${C(e)}
      </span>
    `,c="product-card__price--discounted"),`
    <div class="product-card__price">
      ${l}
      <span class="${c} f1-lc">
        ${C(a)}
      </span>
    </div>`},N=(a,e,l)=>{var k,v,p,_,o,s,$,b,u,h,f,g;if(e&&l&&e<l)return`
      <p class="product-card__label product-label product-label--sale">
        ${Math.round((1-e/l)*100)}% OFF
      </p>
    `;const c=(v=(k=a==null?void 0:a.new)==null?void 0:k[0])==null?void 0:v.label,w=(_=(p=a==null?void 0:a.back_in_stock)==null?void 0:p[0])==null?void 0:_.label,d=(s=(o=a==null?void 0:a.nc_exclusive)==null?void 0:o[0])==null?void 0:s.label,i=(b=($=a==null?void 0:a.available_to_rent)==null?void 0:$[0])==null?void 0:b.label,n=(h=(u=a==null?void 0:a.petite)==null?void 0:u[0])==null?void 0:h.label,t=(g=(f=a==null?void 0:a.stock)==null?void 0:f[0])==null?void 0:g.label;let r="";return t?r="Coming Soon":c?r="New":w?r="Back in Stock":d?r="NC Exclusive":i?r="Available to Rent":n&&(r="Petite"),r?`
      <p class="product-card__label product-label product-label--default">
        ${r}
      </p>
    `:""},S=a=>{var l;const e=((l=a.link)==null?void 0:l.replace("/products/",""))||"";return`
    <span
      class="product-card__wishlist"
      data-wishlist-button
      data-product-id="${a.key}"
      data-product-handle="${e}"
    >
      ${window.themeVars.icons.wishlist}
    </span>
  `};export{P as b};
